import React, { useEffect } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { ProgressBar } from './components/ProgressBar';
import { StickyAlertBar } from './components/StickyAlertBar';
import { StickyCTABar } from './components/StickyCTABar';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { SocialProofToast } from './components/SocialProofToast';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ConsequencesSection } from './components/ConsequencesSection';
import { WhyNothingWorked } from './components/WhyNothingWorked';
import { UniqueMethod } from './components/UniqueMethod';
import { AuthoritySection } from './components/AuthoritySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { WhatYouGetStack } from './components/WhatYouGetStack';
import { BonusSection } from './components/BonusSection';
import { OfferSummary } from './components/OfferSummary';
import { CheckoutSection } from './components/CheckoutSection';
import { TrustMicrosection } from './components/TrustMicrosection';
import { FAQAccordion } from './components/FAQAccordion';
import { EmotionalClosing } from './components/EmotionalClosing';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Reprogramación Interna';
  }, []);
  return <div className="min-h-screen bg-beige font-sans text-teal selection:bg-sage selection:text-teal-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <ProgressBar data-id="element-2" />
      <StickyAlertBar data-id="element-3" />
      <StickyCTABar data-id="element-4" />
      <ExitIntentPopup data-id="element-5" />
      <SocialProofToast data-id="element-6" />

      <main data-id="element-7">
        <HeroSection data-id="element-8" />
        <IdentificationSection data-id="element-9" />
        <ConsequencesSection data-id="element-10" />
        <WhyNothingWorked data-id="element-11" />
        <UniqueMethod data-id="element-12" />
        <AuthoritySection data-id="element-13" />
        <TestimonialsSection data-id="element-14" />
        <BenefitsGrid data-id="element-15" />
        <WhatYouGetStack data-id="element-16" />
        <OfferSummary data-id="element-17" />
        <BonusSection data-id="element-18" />
        <CheckoutSection data-id="element-19" />
        <TrustMicrosection data-id="element-20" />
        <FAQAccordion data-id="element-21" />
        <EmotionalClosing data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
    </div>;
}